import React from 'react'
import useFirestore from '../hooks/useFirestore'
import { motion } from 'framer-motion'

function Modal({ selectedImg, setSelectedImg }) {

  const { docs } = useFirestore('images');

  function deleteHandler(e) {
    alert("going to add delete function soon")
  }

  function handleClick(e) {

    if (e.target.classList.contains('backdrop')) {
      setSelectedImg(null)
    }
  }

  return (
    <motion.div className="backdrop" onClick={handleClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
      <motion.img src={selectedImg} alt="Enlarged picture"
        initial={{ y: "20vh" }}
        animate={{ y: 0 }}

      />
      <button onClick={deleteHandler}>delete me</button>
    </motion.div>
  )
}

export default Modal
